import { Shark, Utils } from "shark-mvc";
import $ from "jquery";

import ClientFollowUp from "../../_shark_models/ClientFollowUp";
import ViewBase from "../ViewBase";

import templateContent from "./construction-site-card-list.html";

import { activityReportComponent } from "../../_shark_jaws/components/activityReportComponent";
import agentFilterComponent from "../../_shark_components/agentFilter/agentFilterComponent";
import applicatorTeamManager from "../../_shark_jaws/managers/applicatorTeamManager";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import { constructionSiteCardActionsComponent } from "../../_shark_components/constructionSiteCardActions/constructionSiteCardActionsComponent";
import constructionSiteCardEditView from "./constructionSiteCardEditView";
import { constructionSiteCardManager } from "../../_shark_jaws/managers/constructionSiteCardManager";
import { constructionSiteMultiDateComponent } from "../../components/constructionSiteMultiDate/constructionSiteMultiDateComponent";
import { dateRangeFilterComponent } from "../../_shark_jaws/components/dateRangeFilter/dateRangeFilterComponent";
import { documentListView } from "../../views/documents/documentListView";
import exportCSVComponent from "../../components/exportCSV/exportCSVComponent";
import { folderManager } from "../../_shark_jaws/managers/folderManager";
import followUpComponent from "../../components/followUp/followUpComponent";
import followUpManager from "../../_shark_jaws/managers/followUpManager";
import getMoreComponent from "../../components/getMore/getMoreComponent";
import { informationModalComponent } from "../../components/informationModal/informationModalComponent";
import liveSearchComponent from "../../_shark_components/liveSearch/liveSearchComponent";
import mainNavComponent from "Components/mainNavComponent";
import { pagerComponent } from "../../_shark_jaws/components/pagerComponent";
import provinceFilterComponent from "../../_shark_components/provinceFilter/provinceFilterComponent";
import { quotationActionsComponent } from "../../_shark_components/quotationActions/quotationActionsComponent";
import { quotationManager } from "../../_shark_jaws/managers/quotationManager";
import refreshListButtonComponent from "../../components/refreshListButton/refreshListButtonComponent";
import showAllContactsButtonComponent from "../../components/showAllContactsButton/showAllContactsButtonComponent";
import statusSmartFilterComponent from "../../components/statusSmartFilter/statusSmartFilterComponent";
import { tableSorterComponent } from "../../_shark_components/tableSorter/tableSorterComponent";
import teamUpManager from "../../_shark_jaws/managers/teamUpManager";
import { userManager } from "../../_shark_jaws/managers/userManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";
import ConstructionSiteCard from "../../_shark_models/ConstructionSiteCard";

class ConstructionSiteCardListView extends ViewBase {
	constructor() {
		super("constructionSiteCardListView");
		this.setTemplate(templateContent);
	}

	afterRender () {
		$(`[data-toggle="popover"]`).popover();
	}

	async beforeLoad () {
		window.scrollTo(0, 0);

		const constructionSiteCardList = Shark.get("constructionSiteCardList");

		activityReportComponent.set("__reportType", "schede cantiere");
		liveSearchComponent.set({searchHint: "Il testo inserito verrà cercato nel nome del contatto, nel luogo di intervento, nella CCA."});
		liveSearchComponent.behavior = "database";
		constructionSiteMultiDateComponent.set("referenceListName", "constructionSiteCardList");
		followUpComponent.set("targetItem", null);

		if (Shark.get("agentList").length === 0) {
			userManager.getList();
		}
		if (!Shark.get("applicatorTeamList") || Shark.get("applicatorTeamList").length === 0) {
			await applicatorTeamManager.getList();
		}

		if (Shark.get("clientList").length === 0) {
			clientManager.getList();
		}

		userManager.getRequireAttentionCounts();//Dave: Avremo le notifiche per aggiornare questi numeri

		tableSorterComponent.setSortField("__startDate", 7, "date");
		tableSorterComponent.set({
			tableContentList: constructionSiteCardList,
		});

		if (constructionSiteCardList.length === 0) {
			this.refreshList(null, true);
		}
		else {
			// Dave.Info: Se ho già una lista faccio un refresh "default" > carica solo se ci sono filtri diversi (es la provincia.)
			this.refreshList();
		}

		this.set({
			__htmlTitle: "Schede Cantiere | IPM HUB"
		});
	}

	// Dave: questa, in futuro, non dovrebbe più servire...
	async checkFolder (guid) {
		const result = await constructionSiteCardManager.checkFolders(guid);
		console.log({result});
		alert("Guarda il risultato nella console");
	}

	constructionSiteCardActionBtn_clickHandler (event, data) {
		const currConstructionSiteCard = Utils.safp(Shark.get("constructionSiteCardList"), "guid", data.guid);
		const currUser = Shark.get("currUser");

		if (currConstructionSiteCard) {
			switch(data.action) {
				case "checkFolder":
					this.checkFolder(data.guid);
					break;
				case "delete":
					if (confirm(`Sei sicur${currUser.getGenderLastLetter()} di voler eliminare la Scheda Cantiere?\n\nSe procedi non potrai annullare!`)) {
						let reason;

						if (currConstructionSiteCard.status === ConstructionSiteCard.STATUS_WAITING) {
							reason = prompt("Per favore indica un motivo per questa eliminazione");
						}
						else if (currConstructionSiteCard.status === ConstructionSiteCard.STATUS_READY_TO_START) {
							reason = prompt("Per favore indica un motivo per questa eliminazione (obbligatorio)");
							if (!reason || reason.trim() === "") {
								return;
							}
						}
						else {
							reason = prompt("Per favore indica un motivo per questa eliminazione (obbligatorio)\n\nRicorda che il Cantiere per questa Scheda è già stato creato, dovresti cancellare e gestire anche quello!!");
							if (!reason || reason.trim() === "") {
								return;
							}
						}

						waitBoxComponent.open();

						constructionSiteCardManager.delete(currConstructionSiteCard, reason || "", false)
						.then(() => {
							waitBoxComponent.close();
							this.refreshList(null, true);
						});
					}
					break;
				case "deleteAndRevertQuotationStatus":
					if (confirm(`Sei sicur${currUser.getGenderLastLetter()} di voler eliminare la Scheda Cantiere e riportare il Preventivo allo status 'In attesa di riscontro dal cliente'?\n\nSe procedi non potrai annullare!\n\nATTENZIONE!!! Se ci sono altre Schede Cantiere legate allo stesso preventivo (es. diversi lotti) NON dovresti compiere questa operazione, chiedi al supporto tecnico!`)) {

						let reason;

						if (currConstructionSiteCard.status === ConstructionSiteCard.STATUS_WAITING) {
							reason = prompt("Per favore indica un motivo per questa modifica");
						}
						else if (currConstructionSiteCard.status === ConstructionSiteCard.STATUS_READY_TO_START) {
							reason = prompt("Per favore indica un motivo per questa modifica (obbligatorio)");
							if (!reason || reason.trim() === "") {
								return;
							}
						}
						else {
							reason = prompt("Per favore indica un motivo per questa modifica (obbligatorio)\n\nRicorda che il Cantiere per questa Scheda è già stato creato, dovresti cancellare e gestire anche quello!!");
							if (!reason || reason.trim() === "") {
								return;
							}
						}

						waitBoxComponent.open();

						constructionSiteCardManager.delete(currConstructionSiteCard, reason || "", true)
						.then(() => {
							waitBoxComponent.close();
							this.refreshList(null, true);
						});
					}
					break;
			}
		}
	}

	exportSystemsReportCSVBtn_clickHandler () {
		const constructionSiteCardList = Shark.get("constructionSiteCardList");

		const csvReport = constructionSiteCardList.map(constructionSiteCard => {
			return constructionSiteCard.systems.map(premisesDestination => {
				return premisesDestination.systems.map(system => {
					return `"${constructionSiteCard.registry.clientName}";"${constructionSiteCard.__siteLocationLabel}";"${premisesDestination.premiseDestination}";"${system.system}";"${system.area}";"${system.thickness}";"${constructionSiteCard.__typeLabel}";"${constructionSiteCard.__statusLabel}";"${constructionSiteCard.extraData.quotationCCA ?? "N/D"}";"${constructionSiteCard.__startDateLabel ?? "N/D"}";"${constructionSiteCard.__endDateLabel ?? "N/D"}"`;
				});
			});
		}).flat(3);

		csvReport.unshift(`"Contatto";"Sede / Zona di intervento";"Area di utilizzo";"Sistema/Ciclo";"MQ";"spessore in mm";"Tipo";"Stato Scheda Cantiere";"CCA";"Partenza prevista";"Fine prevista"`);
		exportCSVComponent.downloadToUser(csvReport.join("\r\n"), "Lista Sistemi da Schede Informative");
	}

	init () {
		this.addComponents([activityReportComponent, agentFilterComponent, constructionSiteCardActionsComponent, constructionSiteMultiDateComponent, dateRangeFilterComponent, exportCSVComponent, followUpComponent, getMoreComponent, informationModalComponent, liveSearchComponent, mainNavComponent, pagerComponent, provinceFilterComponent, quotationActionsComponent, refreshListButtonComponent, showAllContactsButtonComponent, statusSmartFilterComponent, tableSorterComponent, waitBoxComponent]);
	
		const filtersStatus = this.getFiltersStatus();
		const statusFilters = [
			{
				active: filtersStatus?.filters?.[0]?.active !== undefined ? filtersStatus.filters[0].active : true,
				cssClass: "cs-status-waiting",
				label: "In attesa",
				status: 1,
				statusName: "Waiting",
			},
			{
				active: filtersStatus?.filters?.[1]?.active !== undefined ? filtersStatus.filters[1].active : true,
				cssClass: "cs-status-ready",
				label: "pronti a partire",
				status: 5,
				statusName: "ReadyToStart",
			},
			{
				active: filtersStatus?.filters?.[2]?.active !== undefined ? filtersStatus.filters[2].active : true,
				cssClass: "cs-status-started",
				label: "Cantiere in corso",
				status: 2,
				statusName: "CSStarted",
			},
			{
				active: filtersStatus?.filters?.[3]?.active !== undefined ? filtersStatus.filters[3].active : true,
				cssClass: "cs-status-started",
				label: "Cantiere concluso",
				status: [3, 4],
				statusName: "CSEnded",
			},
		];
		statusSmartFilterComponent.setFilters(statusFilters);
	
		const constructionSiteCardListActiveFilters = Shark.getInstance("__smart__", {
			cscEndedCount: 0,
			cscStartedCount: 0,
			readyToStartCount: 0,
			showWaiting: filtersStatus ? filtersStatus.showWaiting : true,
			showCSSEnded: filtersStatus ? filtersStatus.showCSSEnded : false,
			showCSStarted: filtersStatus ? filtersStatus.showCSStarted : false,
			showReadyToStart: filtersStatus ? filtersStatus.showReadyToStart : false,
			waitingCount: 0,
		});
	
		constructionSiteCardListActiveFilters.on("dataChanged", function () {
			constructionSiteCardListView.saveFiltersStatus(this);
	
			if (this.showWaiting || this.showCSSEnded || this.showCSStarted || this.showReadyToStart) {
				constructionSiteCardListView.refreshList();
			}
			else {
				Shark.render();
			}
		});
	
		getMoreComponent.views[this.className] = {
			currentPage: 0,
		};
	
		Shark.set({
			agentList: Shark.get("agentList") || [],
			clientList: Shark.get("clientList") || [],
			constructionSiteCardListActiveFilters,
			constructionSiteCardList: Shark.get("constructionSiteCardList") || [],
		});
	}

	refreshList (range = null, force = false) {
		waitBoxComponent.show();

		let incrementalRequest = false;

		if (!range) {
			getMoreComponent.views[this.className] = {
				currentPage: 0,
			};
			range = getMoreComponent.getCurrentPageRangeForView(this.className);
		}
		else {
			incrementalRequest = true;
		}

		const { agentFilter, dateRangeFilter, constructionSiteCardListActiveFilters, provinceFilter } = Shark.get();
		const filters = constructionSiteCardListActiveFilters.export();

		// Dave: Questa cosa è da revisonare, per ora sto usando il nuovo componente con la vecchia logica dei filtri.
		filters.statuses = statusSmartFilterComponent.getActiveStatuses();
		filters.showWaiting = filters.statuses.includes(1);
		filters.showCSSEnded = filters.statuses.includes(3) || filters.statuses.includes(4);
		filters.showCSStarted = filters.statuses.includes(2);
		filters.showReadyToStart = filters.statuses.includes(5);

		delete filters.cscEndedCount;
		delete filters.cscStartedCount;
		delete filters.readyToStartCount;
		delete filters.waitingCount;

		if (provinceFilter.province !== "all") {
			filters.province = provinceFilter.province;
		}

		if (agentFilter.agentGuid !== "") {
			filters.agentGuid = agentFilter.agentGuid;
		}

		if (!dateRangeFilter.ignoreDateRange) {
			filters.dateFrom = dateRangeFilter.__from;
			filters.dateTo = dateRangeFilter.__to;
		}

		if (this.textFilters) {
			Object.assign(filters, this.textFilters);
		}

		// Dave.ToDo: Portare tutto in una funzione, lo faccio ovunque!
		if (!force) {
			if (localStorage.constructionSiteCardListViewLastFilters) {
				if (localStorage.constructionSiteCardListViewLastFilters === JSON.stringify({filters, range})) {
					refreshListButtonComponent.resetStatus();
					waitBoxComponent.hide();
					return;
				}
			}
		}

		return constructionSiteCardManager.getFilteredList({filters, range, incrementalRequest})
		.then(response => {
			localStorage.constructionSiteCardListViewLastFilters = JSON.stringify({filters, range});

			const provinceForFilterComponentSet = new Set();
			response.data.forEach(item => provinceForFilterComponentSet.add(item.registry.clientProvince));

			let provinceForFilterComponent = Array.from(provinceForFilterComponentSet);
			provinceForFilterComponent.sort();
			provinceForFilterComponent = provinceForFilterComponent.map(item => item.trim() !== "" ? {label: item, value: item} : {label: "- Non impostata", value: ""});

			Shark.set({provinceForFilterComponent});
			waitBoxComponent.hide();

			Shark.render();
			return true;
		});
	}

	replaceCSWorksheet_clickHandler (event, data) {
		const currConstructionSiteCard = Utils.safp(Shark.get("constructionSiteCardList"), "guid", data.guid);

		if (currConstructionSiteCard && confirm("Un Foglio Lavoro Cantiere è già stato inviato, sei sicuro di volerlo sostituire?")) {
			Shark.set({currConstructionSiteCard});
			constructionSiteCardActionsComponent.show("replaceCSWorksheet");
		}
	}

	sendCSWorksheet_clickHandler (event, data) {
		const currConstructionSiteCard = Utils.safp(Shark.get("constructionSiteCardList"), "guid", data.guid);

		if (currConstructionSiteCard) {
			Shark.set({currConstructionSiteCard});
			constructionSiteCardActionsComponent.show("sendCSWorksheet");
		}
	}

	setCCACodeBtn_clickHandler (event, data) {
		const currConstructionSiteCard = Utils.safp(Shark.get("constructionSiteCardList"), "guid", data.guid);

		if (!currConstructionSiteCard.__status_waiting) {
			if (!confirm("Sei sicuro di voler modificare la CCA di questa Scheda Cantiere anche se è già impostata?")) {
				return;
			}
		}
	
		if (currConstructionSiteCard.extraData.lotId === -1) {
			currConstructionSiteCard.extraData.lotId = 0;
		}
		quotationManager.getByGuid(currConstructionSiteCard.quotationGuid)//Dave: Va cambiato con i relatedGuid, non è vero, i relatedGuid sono uno schifo... :)
		.then(getQuotationResponse => {
			if (getQuotationResponse.data.length > 0) {
				const currQuotation = getQuotationResponse.data[0];
				// console.log({currConstructionSiteCard, currQuotation});
				
				if (currQuotation) {
					Shark.set({
						currConstructionSiteCard,
						currQuotation,
					});
					quotationActionsComponent.show("cca");
				}
			}
			else {
				alert("Attenzione, questa Scheda Cantiere non è associata ad un preventivo, per favore segnalare l'errore CSC-LV-195.");
			}
		});
	}

	singleItemRow_clickHandler (event, data) {
		if (event.target.closest(".preventRowClick") !== null) {
			return;
		}

		const currConstructionSiteCard = Utils.safp(Shark.get("constructionSiteCardList"), "guid", data.guid);
	
		if (currConstructionSiteCard) {
			Shark.set({currConstructionSiteCard});
			followUpComponent.set("targetItem", currConstructionSiteCard);
			Shark.openPage(constructionSiteCardEditView);
		}
	}

	skipCSWorksheet_clickHandler (event, data) {
		const currConstructionSiteCard = Utils.safp(Shark.get("constructionSiteCardList"), "guid", data.guid);
	
		if (currConstructionSiteCard.extraData.quotationCCA === "") {
			alert("Attenzione, per poter compiere questa operazione devi avere già impostato la CCA!");
			return;
		}

		const currUser = Shark.get("currUser");

		if (confirm(`Attenzione!\n\nSe prosegui cliccando 'ok' questa Scheda Cantiere verrà impostata come 'pronta a partire' e verrà segnata come 'non necessita di Foglio Lavoro Cantiere'.\n\nSe sicur${currUser.getGenderLastLetter()} di voler proseguire?`)) {
			
			if (currConstructionSiteCard) {
				waitBoxComponent.open();

				let newStatus = currConstructionSiteCard.status;
				let statusMessage = "";
	
				if (currConstructionSiteCard.status === 1 && currConstructionSiteCard.extraData.quotationCCA !== "") {
					newStatus = 5;
					statusMessage = "\nIl Cantiere è ora pronto a partire.\n";
				}
	
				currConstructionSiteCard.set({
					["extraData.constructionSiteWorksheetSkipped"]: true,
					status: newStatus,
				});
	
				constructionSiteCardManager.save(currConstructionSiteCard)
				.then(() => {
					const referenceAgent = Utils.safp(Shark.get("userList"), "guid", currConstructionSiteCard.userGuid);
					const lotReference = currConstructionSiteCard.__lotId > -1 ? " lotto #" + (currConstructionSiteCard.__lotId + 1) : "";
					
					//Dave: Qui c'è da rimettere in ordine le cose che faccio sempre, solo quando si aggiorna, solo quando si crea
					// Non mandiamo di nuovo la mail se cambia il documento.
					const body = `BuonGiorno ${referenceAgent.firstName},
					
						questa eMail per comunicarti che per la Scheda Cantiere <strong>${currConstructionSiteCard.__siteLocationLabel}</strong> ${lotReference} con partenza prevista il <strong>${currConstructionSiteCard.__startDateLabel}</strong> per il Cliente <strong>${currConstructionSiteCard.registry.clientName}</strong> è stato indicato che non è necessario il Foglio Lavoro Cantiere.
						${statusMessage}

						Buona Giornata,
						IPM HUB


						<small>Questa eMail è stata generata in automatico, per favore non rispondere.</small>
					`;

					const currMessage = Shark.getInstance(null, {
						body,
						senderEMail: currUser.email,
						senderName: currUser.__fullName,
						subject: "IPM HUB | Cantiere pronto a partire",
						receiverEMail: referenceAgent.email,
						receiverName: referenceAgent.__fullName,
					});
					userManager.sendMessage(currMessage);
	
					const newFollowUp = new ClientFollowUp({
						body: `Il Cantiere <strong>${currConstructionSiteCard.__siteLocationLabel}</strong>${lotReference} è stato impostato come "non necessita di Foglio Lavoro Cantiere" ed è quindi pronto a partire.`,
						clientGuid: currConstructionSiteCard.clientGuid,
						referenceGuid: currConstructionSiteCard.guid,
						referenceType: "constructionSiteCard",
						status: 3,
						type: "system"
					});
	
					followUpManager.save(newFollowUp)
					.then(() => {
						if (newStatus === 5) {
							setTimeout(() => {
								constructionSiteCardManager.checkCommunicateStarting(currConstructionSiteCard);
							}, 500);
						}
	
						waitBoxComponent.close();
						Shark.render();
					});
				});
			}
		}
	}

	updateDateBtn_clickHandler (event, data) {
		const currConstructionSiteCard = Utils.safp(Shark.get("constructionSiteCardList"), "guid", data.guid);

		if (currConstructionSiteCard) {
			let quotationCCA = currConstructionSiteCard.extraData.quotationCCA.trim();

			if (quotationCCA === "") {
				quotationCCA = currConstructionSiteCard.__ccaLabel;
			}

			if (quotationCCA !== "") {
				event.target.classList.add("loading");

				teamUpManager.updateDataByCCA(quotationCCA)
				.then(response => {
					// console.log({response});
					event.target.classList.remove("loading");

					if (!response.constructionSiteCard) {
						informationModalComponent.show({body: "Attenzione, la CCA inserita non corrisponde a nessun evento sul calendario TeamUp", title: "Informazione"});
					}
					else {
						this.refreshList();
						// Shark.render();
					}
				});
			}
		}
	}

	updateTextFilters (searchKey) {
		if (searchKey && searchKey !== "") {
			this.textFilters = {
				clientName: searchKey,
				quotationCCA: searchKey,
				siteLocation: searchKey,
			};
		}
		else {
			this.textFilters = null;
		}

		this.refreshList()
		.then(() => {
			if (searchKey !== "") {
				liveSearchComponent.setFocus();
			}
		});
	}

	updateTotals () {
		let constructionSiteCardList = Shark.get("constructionSiteCardList");
		let presumedAmountTotal = 0;

		constructionSiteCardList.forEach(item => {
			const node = document.querySelector(`.singleItemRow[data-guid="${item.guid}"]`);

			if (node && !node.classList.contains("d-none") && node.style.display !== "none") {
				presumedAmountTotal += item.__presumedAmount ? parseFloat(item.__presumedAmount) : 0;
			}
		});

		// const formatterCurrency = new Intl.NumberFormat("it-IT", { currency: "EUR", style: "currency" });
		// const __presumedAmountTotalLabel = formatterCurrency.format(presumedAmountTotal);
		const __presumedAmountTotalLabel = Shark.$store.currencyFormatter.format(presumedAmountTotal);
	
		this.set({
			__presumedAmountTotalLabel,
		});

		const node = document.querySelector(`[data-ref="presumedAmountTotal"]`);
		if (node) {
			node.innerHTML = __presumedAmountTotalLabel;
		}
	}






	
	afterComponentsPreRender () {
		let constructionSiteCardList = Shark.get("constructionSiteCardList");

		if (constructionSiteCardList) {
			// const [agentFilter, constructionSiteCardListActiveFilters, dateRangeFilter, provinceFilter] = Shark.get(["agentFilter", "constructionSiteCardListActiveFilters", "dateRangeFilter", "provinceFilter"]);
			let __presumedAmountTotal = 0;

			constructionSiteCardList.forEach((item) => {
				// if (!dateRangeFilter.ignoreDateRange && (item.__startDate < dateRangeFilter.__from || item.__startDate > dateRangeFilter.__to) && (item.__endDate < dateRangeFilter.__from || item.__endDate > dateRangeFilter.__to) && (item.__updatedAt < dateRangeFilter.__from || item.__updatedAt > dateRangeFilter.__to)) {
				// 	item.__render = false;
				// }
				// else {
				// 	item.__render =	item.status === 1 && constructionSiteCardListActiveFilters.showWaiting ||
				// 	[3, 4].indexOf(item.status) > -1 && constructionSiteCardListActiveFilters.showCSSEnded ||
				// 	item.status === 2 && constructionSiteCardListActiveFilters.showCSStarted ||
				// 	item.status === 5 && constructionSiteCardListActiveFilters.showReadyToStart
				// 	;
				// }

				// if (item.__render && agentFilter.agentGuid !== "" && item.userGuid !== agentFilter.agentGuid) {
				// 	item.__render = false;
				// }

				// if (item.__render && provinceFilter.province !== "all" && provinceFilter.province !== item.registry.clientProvince) {
				// 	item.__render = false;
				// }
				// if (item.__render) {
				// counter++;
				__presumedAmountTotal += item.__presumedAmount ? parseFloat(item.__presumedAmount) : 0;
				// }
			});

			const __presumedAmountTotalLabel = Shark.$store.currencyFormatter.format(__presumedAmountTotal);

			this.set({
				__presumedAmountTotalLabel,
			});
		}

		Shark.set({ activityReport: activityReportComponent.extractReport(constructionSiteCardList) });
	}

	beforeRender () {
		const constructionSiteCardList = Shark.get("constructionSiteCardList");

		tableSorterComponent.set({
			tableContentList: constructionSiteCardList
		});

		followUpComponent.set({
			sourceList: constructionSiteCardList
		});
	}

	showFolderBtn_clickHandler (event, data) {
		const currConstructionSiteCard = Utils.safp(Shark.get("constructionSiteCardList"), "guid", data.guid);

		if (currConstructionSiteCard) {
			folderManager.getPathByReferenceGuid(currConstructionSiteCard.extraData.siteInfoSheetGuid, "siteInfoSheet")
			.then(folderResponse => {
				// console.log({folderResponse});
				
				if (folderResponse.data.length > 0) {
					Shark.set({
						requestedFolderBreadCrumb: folderResponse.data
					});
					Shark.openPage(documentListView);
				}
			});
		}
	}
}

const constructionSiteCardListView = new ConstructionSiteCardListView();

Shark.registerView(constructionSiteCardListView);

export default constructionSiteCardListView;
